import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { states } from '../mockData/states-data';

const StatesApi = [rest.get(`${API_ROOT}states`, (req, res, ctx) => res(ctx.json(states)))];
export default StatesApi;
